export interface IBoatType {
  id: number;
  name: string | null;
  active: boolean | null;
  minCrew: number | null;
  maxCrew: number | null;
}
export class BoatType implements IBoatType {
  id;
  name;
  active;
  minCrew;
  maxCrew;

  constructor(config: IBoatType) {
    this.id = config.id;
    this.name = config.name;
    this.active = config.active;
    this.minCrew = config.minCrew;
    this.maxCrew = config.maxCrew;
  }
}
